import React from 'react';

const Loading = () => {
   
    return (
        <div className='h-screen flex justify-center items-center'>
            <button className='btn loading'>Loading...</button>
        </div>
    );
};

export default Loading;